<template>
    <div :class="$style.selfExport">
        <base-card title_center>
            <template v-slot:title>
                <div :class="$style.card_title">
                    订单列表
                </div>
            </template>
            <template v-slot:right>
                <el-checkbox-group v-model="searchArr.order">
                    <el-checkbox false-label="" true-label="1" name="status"></el-checkbox>
                </el-checkbox-group>
            </template>
            <template v-slot:content>
                <tyc-order-condiction ref="order-condiction" />
            </template>
        </base-card>
        <base-card title_center style="margin-top: 0.2rem;">
            <template v-slot:title>
                <div :class="$style.card_title">
                    用户列表
                </div>
            </template>
            <template v-slot:right>
                <el-checkbox-group v-model="searchArr.user">
                    <el-checkbox false-label="" true-label="1" name="status"></el-checkbox>
                </el-checkbox-group>
            </template>
            <template v-slot:content>
                <user-condiction ref="user-condiction" />
            </template>
        </base-card>
        <base-card title_center style="margin-top: 0.2rem;">
            <template v-slot:title>
                <div :class="$style.card_title">
                    线索列表
                </div>
            </template>
            <template v-slot:right>
                <el-checkbox-group v-model="searchArr.clue">
                    <el-checkbox false-label="" true-label="1" name="status"></el-checkbox>
                </el-checkbox-group>
            </template>
            <template v-slot:content>
                <clue-condiction ref="clue-condiction" />
            </template>
        </base-card>
        <base-card title_center style="margin-top: 0.2rem;">
            <template v-slot:title>
                <div :class="$style.card_title">导出格式</div>
            </template>
            <template v-slot:right>
                <el-checkbox-group v-model="encryptType">
                    <el-checkbox false-label="" true-label="md5" name="status">md5</el-checkbox>
                    <el-checkbox false-label="" true-label="sha256" name="status">sha256</el-checkbox>
                </el-checkbox-group>
            </template>
            <template v-slot:content>
                <excel-type ref="excel-type" />
                <export-condiction ref="export-condiction" style="margin-top: 0.2rem;margin-left: -0.2rem;"/>
                <el-row style="margin-top: 0.2rem;" type="flex" align="middle">
                    <el-col :span="1">
                        <span style="color:#409EFF;white-space: nowrap;flex-shrink: 0;">备注: </span>
                    </el-col>
                    <el-col :span="23">
                        <el-input v-model="mark" size="mini" maxlength="110" clearable show-word-limit></el-input>
                    </el-col>
                </el-row>
            </template>
        </base-card>
        <div style="text-align: center;margin-top: 0.2rem;">
            <!-- <el-button type="primary" size="mini" @click="handleExport">导出</el-button> -->
            <el-dropdown split-button type="primary" size="mini" @click="handleExport">
                <span style="line-height: 9px;vertical-align: middle;">导出</span>
                <el-dropdown-menu slot="dropdown" style="vertical-align: middle;">
                    <el-dropdown-item><span @click="openImportSelfPhoneDialog()">任务详情</span></el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>

        <el-dialog :visible.sync="dialog_selfExport" @close="closeDialog_selfExport"
            @beforeClose="beforeCloseDialog_selfExport" width="50%" center append-to-body>
            <template v-slot:title>
                <span style="font-weight: bold;font-size: medium;color: #409EFF;">
                    任务详情
                </span>
            </template>
            <self-export-task v-if="dialog_selfExport" :openType=1 />
        </el-dialog>
    </div>
</template>

<script>
const loadAutoHyperHost = () => import('@/config').then(module => module.AutoHyperfHost);
export default {
    name: 'SelfExport',
    components: {
        'base-card': () => import('@/YsyCollections/ElementUi/PureElementUi/V2.12.0/Card/BaseCard'),
        'excel-type': () => import('@/YsyCollections/ElementUi/CombinationsElementUi/V2.12.0/ExcelType'),
        'tyc-order-condiction': () => import('@/pages/SelfExport/Components/TycOrderCondiction'),
        'user-condiction': () => import('@/pages/SelfExport/Components/UserCondiction'),
        'clue-condiction': () => import('@/pages/SelfExport/Components/ClueCondiction'),
        'self-export-task': () => import('@/pages/SelfExport/Components/SelfExportTask'),
        'export-condiction': () => import('@/common/components/ExportCondiction'),
    },
    data() {
        return {
            searchArr: {
                order: '1',
                user: '1',
                clue: '1',
            },
            encryptType: 'md5',
            mark: '',
            dialog_selfExport: false
        }
    },
    methods: {
        async getExecuteUrl() {
            const host = await loadAutoHyperHost()
            return `${host}qyh/self_export/export`;
        },
        async handleExport() {
            const url = await this.getExecuteUrl();
            this.searchArr.orderSearchArr = this.$refs['order-condiction'].searchArr
            this.searchArr.userSearchArr = this.$refs['user-condiction'].searchArr
            this.searchArr.clueSearchArr = this.$refs['clue-condiction'].searchArr
            const phoneLocation = this.$refs['export-condiction'].searchArr.area
            this.searchArr.orderSearchArr['phoneLocation'] = phoneLocation
            this.searchArr.userSearchArr['phoneLocation'] = phoneLocation
            this.searchArr.clueSearchArr['phoneLocation'] = phoneLocation
            this.$axios.get(url, {
                loadingClose: true,
                params: {
                    excelType: this.$refs['excel-type'].excelType,
                    exportCondiction: this.searchArr,
                    encryptType: this.encryptType,
                    mark: this.mark,
                }
            }).then(({ data }) => {
                if (data.code === 0) {
                    this.$message.success(data.msg)
                }
            }).catch()
        },
        openImportSelfPhoneDialog() {
            this.dialog_selfExport = true
        },
        closeDialog_selfExport() {
        },
        beforeCloseDialog_selfExport() {

        },
    },
}
</script>

<style module>
.selfExport {
    padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}

.card_title {
    color: #409EFF;
    font-Weight: bold;
    font-size: medium;
}
</style>


// WEBPACK FOOTER //
// src/pages/SelfExport/SelfExport.vue